import { Checks } from './types';

export function getRelativeMarkerTimings(
  checks: Checks,
  routeStartTimestamp: number
): Record<string, number> {
  const timings: Record<string, number> = {};
  Object.keys(checks).forEach((marker) => {
    if (checks[marker]) {
      timings[marker] = checks[marker].timestamp - routeStartTimestamp;
    }
  });
  return timings;
}
